import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import TrainingAssistanceServices from "./trainingAssistance.services";
import trainingAssistanceServices from "./trainingAssistance.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTrainingAssistance = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_TRAINING_ASSISTANCE,
      payload: true,
    });
    const resp = await TrainingAssistanceServices.getTrainingAssistance(
      filters
    );
    // const resp2 = await TrainingAssistanceServices.getTrainingAssistance({
    //   tipo_busqueda: filters.tipo_busqueda,
    //   filter: filters.filter,
    // });
    // const _resp = resp.data
    dispatch({
      type: actions.GET_TRAINING_ASSISTANCE,
      payload: {
        trainingAssistance: resp.data,
        // trainingAssistanceAll: resp.data,
      },
    });
    dispatch({
      type: actions.TRAINING_ASSISTANCE_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TRAINING_ASSISTANCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_TRAINING_ASSISTANCE,
      payload: false,
    });
  }
};

export const resetAsistanceMassiveUpload = () => async (dispatch) => {
    dispatch({
      type: actions.TRAINING_ASSISTANCE_UPLOAD_PROBLEMS,
      payload: [],
    });
    dispatch({
      type: actions.TRAINING_ASSISTANCE_UPLOAD_FAIL,
      payload: "",
    });
  };

export const saveAsistanceMassiveUpload =
  (req, setExcelData, item, _getTrainingAssistance, setShowModalMaciveUpload) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADER_TRAINING_ASSISTANCE_UPLOAD,
        payload: true,
      });
      const resp = await TrainingAssistanceServices.saveAsistanceMassiveUpload(req);
      const _resp = resp.data.listado_colaboradores_no_aceptados
      dispatch({
        type: actions.TRAINING_ASSISTANCE_UPLOAD_PROBLEMS,
        payload: _resp,
      });
      setExcelData(null);
      item.archivo_excel = "";
      _getTrainingAssistance()
      if(_resp.length === 0){
        setShowModalMaciveUpload(false)
        dispatch({
          type: actions.TRAINING_ASSISTANCE_UPLOAD_FAIL,
          payload: "",
        });
        toastr.success(messages.fileSuccessMessage, "", {
          progressBar: true,
          rtl: true,
        });
        // _getTrainingAssistance()
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.TRAINING_ASSISTANCE_UPLOAD_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_TRAINING_ASSISTANCE_UPLOAD,
        payload: false,
      });
    }
  };

export const getTrainingAssistanceById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_TRAINING_ASSISTANCE,
      payload: true,
    });
    const resp = await TrainingAssistanceServices.getTrainingAssistanceById(id);
    dispatch({
      type: actions.GET_TRAINING_ASSISTANCE,
      payload: {
        trainingAssistance: resp.data,
      },
    });
    dispatch({
      type: actions.TRAINING_ASSISTANCE_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.TRAINING_ASSISTANCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_TRAINING_ASSISTANCE,
      payload: false,
    });
  }
};

export const saveTrainingAssistance =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_TRAINING_ASSISTANCE,
        payload: true,
      });
      const resp = await TrainingAssistanceServices.saveTrainingAssistance(req);
      const { data, count, asistencia_total, inasistencia_total } =
        getState().trainingAssistance.trainingAssistance;
      // const {
      //   data: dataAll,
      //   count: countAll,
      //   asistencia_total: asistencia_totalAll,
      //   inasistencia_total: inasistencia_totalAll,
      // } = getState().trainingAssistance.trainingAssistanceAll;
      let _asistenciaTotal, _inasistenciaTotal;
      // _asistencia_totalAll,
      // _inasistencia_totalAll;
      if (resp.data.asistio) {
        _asistenciaTotal = asistencia_total + 1;
        // _asistencia_totalAll = asistencia_totalAll + 1;

        _inasistenciaTotal = inasistencia_total;
        // _inasistencia_totalAll = inasistencia_totalAll;
      } else {
        _inasistenciaTotal = inasistencia_total + 1;
        // _inasistencia_totalAll = inasistencia_totalAll + 1;

        _asistenciaTotal = asistencia_total;
        // _asistencia_totalAll = asistencia_totalAll;
      }
      dispatch({
        type: actions.GET_TRAINING_ASSISTANCE,
        payload: {
          trainingAssistance: {
            count: count + 1,
            data: [...data, resp.data],
            asistencia_total: _asistenciaTotal,
            inasistencia_total: _inasistenciaTotal,
          },
          // trainingAssistanceAll: {
          //   count: countAll + 1,
          //   data: [...dataAll, resp.data],
          //   asistencia_total: _asistencia_totalAll,
          //   inasistencia_total: _inasistencia_totalAll,
          // },
        },
      });
      dispatch({
        type: actions.FORM_TRAINING_ASSISTANCE_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              if (ex.response.data[0]) {
                toastr.info(ex.response.data[0]);
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_TRAINING_ASSISTANCE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_TRAINING_ASSISTANCE,
        payload: false,
      });
    }
  };

export const sendCorreoFacilitador =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_TRAINING_ASSISTANCE_CORREO_FACILITADOR,
        payload: true,
      });
      const resp = await trainingAssistanceServices.sendCorreoFacilitador(req);

      dispatch({
        type: actions.GET_TRAINING_ASSISTANCE_CORREO_FACILITADOR,
        payload: resp.data,
      });
      dispatch({
        type: actions.FORM_TRAINING_ASSISTANCE_FAIL_CORREO_FACILITADOR,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_TRAINING_ASSISTANCE_FAIL_CORREO_FACILITADOR,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_TRAINING_ASSISTANCE_CORREO_FACILITADOR,
        payload: false,
      });
    }
  };

export const editTrainingAssistance =
  (req, index, setShowModal, offset, asistio, reqAsistio) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_TRAINING_ASSISTANCE,
        payload: true,
      });
      const resp = await TrainingAssistanceServices.editTrainingAssistance(
        req.id,
        req
      );
      const { data, count, asistencia_total, inasistencia_total } =
        getState().trainingAssistance.trainingAssistance;
      // const {
      //   data: dataAll,
      //   count: countAll,
      //   asistencia_total: asistencia_totalAll,
      //   inasistencia_total: inasistencia_totalAll,
      // } = getState().trainingAssistance.trainingAssistanceAll;
      let _asistenciaTotal, _inasistenciaTotal;
      // _asistencia_totalAll,
      // _inasistencia_totalAll
      if (resp.data.asistio) {
        if (!asistio) {
          _asistenciaTotal = asistencia_total + 1;
          // _asistencia_totalAll = asistencia_totalAll + 1;
          if (inasistencia_total > 0) {
            _inasistenciaTotal = inasistencia_total - 1;
            // _inasistencia_totalAll = inasistencia_totalAll - 1;
          } else {
            _inasistenciaTotal = 0;
            // _inasistencia_totalAll = 0;
          }
        } else {
          _asistenciaTotal = asistencia_total;
          // _asistencia_totalAll = asistencia_totalAll;
          _inasistenciaTotal = inasistencia_total;
          // _inasistencia_totalAll = inasistencia_totalAll;
        }
      } else {
        if (asistio) {
          _inasistenciaTotal = inasistencia_total + 1;
          // _inasistencia_totalAll = inasistencia_totalAll + 1;
          if (asistencia_total > 0) {
            _asistenciaTotal = asistencia_total - 1;
            // _asistencia_totalAll = asistencia_totalAll - 1;
          } else {
            _asistenciaTotal = 0;
            // _asistencia_totalAll = 0;
          }
        } else {
          _asistenciaTotal = asistencia_total;
          // _asistencia_totalAll = asistencia_totalAll;
          _inasistenciaTotal = inasistencia_total;
          // _inasistencia_totalAll = inasistencia_totalAll;
        }
      }
      let _data = data.slice();
      // let _dataAll = dataAll.slice();
      _data[index] = resp.data;
      // _dataAll[index + offset] = resp.data;
      dispatch({
        type: actions.GET_TRAINING_ASSISTANCE,
        payload: {
          trainingAssistance: {
            data: _data,
            count: count,
            asistencia_total: _asistenciaTotal,
            inasistencia_total: _inasistenciaTotal,
          },
          // trainingAssistanceAll: {
          //   data: _dataAll,
          //   count: countAll,
          //   asistencia_total: _asistencia_totalAll,
          //   inasistencia_total: _inasistencia_totalAll,
          // },
        },
      });
      dispatch({
        type: actions.FORM_TRAINING_ASSISTANCE_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      if (!req.asistio) {
        await TrainingAssistanceServices.sendNotifications(reqAsistio);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.TRAINING_ASSISTANCE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_TRAINING_ASSISTANCE,
        payload: false,
      });
    }
  };

export const deleteTrainingAssistance =
  (id, index, offset, asistio) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_TRAINING_ASSISTANCE,
        payload: true,
      });
      await TrainingAssistanceServices.deleteTrainingAssistance(id);
      const { data, count, asistencia_total, inasistencia_total } =
        getState().trainingAssistance.trainingAssistance;
      // const {
      //   data: dataAll,
      //   count: countAll,
      //   asistencia_total: asistencia_totalAll,
      //   inasistencia_total: inasistencia_totalAll,
      // } = getState().trainingAssistance.trainingAssistanceAll;
      let _asistenciaTotal, _inasistenciaTotal;
      // _asistencia_totalAll,
      // _inasistencia_totalAll
      if (asistio) {
        _asistenciaTotal = asistencia_total - 1;
        // _asistencia_totalAll = asistencia_totalAll - 1;
        _inasistenciaTotal = inasistencia_total;
        // _inasistencia_totalAll = inasistencia_totalAll;
      } else {
        _inasistenciaTotal = inasistencia_total - 1;
        // _inasistencia_totalAll = inasistencia_totalAll - 1;
        _asistenciaTotal = asistencia_total;
        // _asistencia_totalAll = asistencia_totalAll;
      }
      let _data = data.slice();
      // let _dataAll = dataAll.slice();
      _data.splice(index, 1);
      // _dataAll.splice(index + offset, 1);
      dispatch({
        type: actions.GET_TRAINING_ASSISTANCE,
        payload: {
          trainingAssistance: {
            data: _data,
            count: count - 1,
            asistencia_total: _asistenciaTotal,
            inasistencia_total: _inasistenciaTotal,
          },
          // trainingAssistanceAll: {
          //   data: _dataAll,
          //   count: countAll - 1,
          //   asistencia_total: _asistencia_totalAll,
          //   inasistencia_total: _inasistencia_totalAll,
          // },
        },
      });
      dispatch({
        type: actions.TRAINING_ASSISTANCE_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.TRAINING_ASSISTANCE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_TRAINING_ASSISTANCE,
        payload: false,
      });
    }
  };

export const sendNotifications =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_TRAINING_ASSISTANCE,
        payload: true,
      });
      await TrainingAssistanceServices.sendNotifications(req);
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.length > 0) {
                message = ex.response.data[0];
              } else {
                message = ex.response.data;
              }

              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //    type: actions.FORM_FORMULARIO_COMPETENCIA_FAIL,
      //    payload: message,
      //  });
      toastr.info(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_TRAINING_ASSISTANCE,
        payload: false,
      });
    }
  };

export const sendNotificationsButton = (req) => async (dispatch) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_TRAINING_ASSISTANCE,
      payload: true,
    });
    await TrainingAssistanceServices.sendNotificationsButton(req);
    toastr.success(messages.correoEnviado, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.length > 0) {
              message = ex.response.data[0];
            } else {
              message = ex.response.data;
            }

            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //    type: actions.FORM_FORMULARIO_COMPETENCIA_FAIL,
    //    payload: message,
    //  });
    toastr.info(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_TRAINING_ASSISTANCE,
      payload: false,
    });
  }
};
